module.exports = __webpack_public_path__ + "static/media/resturant-menu-theme-4.61957de8.jpg";